import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

const SavingErrorDialog = props => {
  const { show, cancel } = props;
  return (
    <div className={show ? "modal is-active" : "modal"}>
      <div className="modal-background" />
      <div className="modal-content">
        <div className="box">
          <div className="content">
            <h3>Błąd zapisu danych w bazie.</h3>
            <p>
              Niestety nie udało się zapisać danych w bazie. Prawdopodobnie błąd
              jest chwilowy. Prosimy o ponowienie próby zapisu za kilka minut.
            </p>
          </div>
          <div className="level">
            <div className="level-left" />
            <div className="level-right">
              <div className="level-item">
                <button className="button is-medium" onClick={() => cancel()}>
                  Zamknij
                </button>
              </div>
            </div>
          </div>
        </div>
        <button
          className="modal-close is-large"
          onClick={() => cancel("zamknieto okno")}
          aria-label="close"
        />
      </div>
    </div>
  );
};
SavingErrorDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  cancel: PropTypes.func.isRequired
};
export default withRouter(SavingErrorDialog);



// WEBPACK FOOTER //
// ./src/components/poll/SavingErrorDialog.js